import { render } from "./ShareBtn.vue?vue&type=template&id=f080cfe0"
import script from "./ShareBtn.vue?vue&type=script&lang=js"
export * from "./ShareBtn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__